import { RouteUtils } from "@rsm-hcd/javascript-react";
import { siteMap } from "internal-sitemap";
import { useCallback } from "react";
import useCurrentPage from "utilities/hooks/domain/notebooks/pages/use-current-page";
import useCurrentNotebook from "utilities/hooks/domain/notebooks/use-current-notebook";

const UseNotebookSidebar = () => {
    const { currentNotebook } = useCurrentNotebook();
    const { currentPage } = useCurrentPage();

    const notebookRoute = useCallback(
        (id: number) =>
            RouteUtils.getUrl(siteMap.notebooks.notebook.detail, {
                notebookId: id,
            }) as string,
        []
    );

    const pageRoute = useCallback(
        (pageId: number, notebookId: number) =>
            RouteUtils.getUrl(siteMap.notebooks.notebook.page, {
                notebookId: notebookId,
                pageId: pageId,
            }),
        []
    );

    const isCurrentNotebook = (notebookId: number) => {
        return notebookId === currentNotebook?.id;
    };

    const pageIsOpen = () => {
        return currentPage != null;
    };

    const getNotebookClassModifier = (notebookId: number) => {
        if (isCurrentNotebook(notebookId)) {
            if (pageIsOpen()) {
                return "-currentNotebookWithOpenPage -currentNotebook";
            }
            return "-currentNotebook";
        }
        return "";
    };

    const getPageClassModifier = (pageId: number) => {
        return `${currentPage?.id === pageId ? "-currentPage" : ""}`;
    };

    return {
        notebookRoute,
        pageRoute,
        getNotebookClassModifier,
        getPageClassModifier,
    };
};

export default UseNotebookSidebar;
